import { PanoramaStream } from "@lvt/streaming";
import { Dialog, IconButton } from "@material-ui/core";
import { Typography } from "@material-ui/core";
// import { Alert as ToastAlert } from "@material-ui/lab";
import { Close, Download, Videocam } from "@mui/icons-material";
import { DateTime } from "luxon";
// import { useSnackbar } from "notistack";
// import { useTranslation } from "react-i18next";

import { RequestedVideo } from "@/api/requestedVideos";
import { ClickAndDrag } from "@/common/components/SVG/Svg";
// import { Severity } from "@/store/alerts/slice";

import useStyles from "./PreviewModal.styles";


export interface PreviewModalProps {
    /**
     * Flag to hide/show the modal.
     */
    open: boolean;
    /**
     * Handler to close the modal.
     */
    onClose: () => void;
    /**
     * Video data for the UI and video playback.
     */
    video: RequestedVideo;
}

const PreviewModal: React.FC<PreviewModalProps> = ({ open, onClose, video }) => {
    // const { t } = useTranslation("translation", { keyPrefix: "components.requestedVideos" });
    const styles = useStyles();
    // const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const isDewarpedVideo = video.dewarpedVideoUrl;

    // This function was being used onError attribute for an <a> effectively not working
    // const onDownloadFail = () => {
    //     closeSnackbar(video.id);

    //     const alert = (
    //         <ToastAlert severity="error">
    //             {t("errors.download")}
    //         </ToastAlert>
    //     );

    //     enqueueSnackbar(alert, {
    //         anchorOrigin: {
    //             vertical: "bottom",
    //             horizontal: "right",
    //         },
    //         autoHideDuration: 8000,
    //         preventDuplicate: true,
    //         variant: Severity.Error,
    //     });
    // };

    const emDash = <div>&#8212;</div>;
    const pipe = <div>&#124;</div>;
    const degree = <span>&#176;</span>;

    return (
        <Dialog open={open} classes={{ paperWidthSm: styles.dialog }}>
            <div className={styles.video}>
                {(video.dewarpedVideoUrl)
                    ? <PanoramaStream
                            videoUrl={video.dewarpedVideoUrl}
                    />
                    : <video
                            autoPlay
                            className={styles.video}
                            controls
                            src={video.videoUrl}
                            controlsList="nodownload"
                            muted={!open}
                            data-testid="preview-video"
                    />
                }
                <IconButton
                    id={`requested-videos_preview-modal_${video.id}_close-button`}
                    className={styles.close}
                    onClick={onClose}
                >
                    <Close />
                </IconButton>
            </div>
            <div>
                {isDewarpedVideo && <div className={styles.panoVideoBanner}>
                    <ClickAndDrag />
                    <Typography className={styles.panoVideoBannerTitle}>
                        <strong>Panoramic 360{degree} View</strong>: Click and drag the video to change the view.
                    </Typography>
                </div>}
                <div className={styles.footer}>
                    <div>
                        <div className={styles.primaryText}>
                            <div>{video.locationName}</div>
                            {pipe}
                            <div>{video.name}, {video.liveUnitSerialNumber}</div>
                            {emDash}
                            <div className={styles.camera}>
                                <Videocam />
                                {video.name}
                            </div>
                        </div>

                        <div className={styles.secondaryText}>
                            {video.recordedDatetime && video.locationTimezone ?
                                <>
                                    <div>
                                        {/* {t("recorded")}: {DateTime.fromISO(video.recordedDatetime).setLocale(i18n.language).toLocaleString(DateTime.DATE_MED)},
                                    {DateTime.fromISO(video.recordedDatetime).setLocale(i18n.language).toLocaleString({ hour: '2-digit', minute: "2-digit", timeZoneName: "short" })},
                                    {t("timezone")}: {video.locationTimezone} */}
                                        Recorded: {DateTime.fromISO(video.recordedDatetime, { zone: "utc" }).setZone(video.locationTimezone).toLocaleString(DateTime.DATE_MED)},&nbsp;
                                        {DateTime.fromISO(video.recordedDatetime, { zone: "utc" }).setZone(video.locationTimezone).toLocaleString({ hour: "2-digit", minute: "2-digit", timeZoneName: "short" })},&nbsp;
                                        TZ: {video.locationTimezone}
                                    </div>
                                    {pipe}
                                </>
                                :
                                { emDash }
                            }

                            {video.requestedByEmail &&
                                <div>Requested By: {video.requestedByEmail}</div>
                            }
                        </div>
                    </div>

                    <a
                        id={`requested-videos_preview-modal_${video.id}_download-button`}
                        download
                        data-testid="download-button"
                        href={video.dewarpedVideoUrl ?? video.videoUrl}
                        onClick={e => e.stopPropagation()}
                        // This doesnt work/ on error is not a valid attribute for anchor tags - Does not fire in case of error
                        // If we want to handle error case we need to handle throgh javascript
                        // onError={onDownloadFail}
                    >
                        <IconButton className={styles.download}>
                            <Download />
                        </IconButton>
                    </a>
                </div>
            </div>
        </Dialog>
    );
};

export default PreviewModal;
